import React from 'react';
import Btn, { BtnModifier } from '../../../components/molecules/Btn';
import { Icons } from '../../../components/atoms/SVG';
import { TooltipPlacement } from '../../../components/atoms/Tooltip';
import { TopContentResult } from '../../../components/molecules/Form/components/ComboBox';
import { useHtmlValidId } from '../../../hooks/useHtmlValidId';
import { PrivilegedGroupParam } from './PrivilegedGroupsAddForm';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { FormsComboboxMultiSelectListElement } from
  '../../../components/molecules/Form/components/FormsComboboxMultiSelect/partials/FormsComboboxMultiSelectListElement';
import { FormsComboboxMultiselectSelection } from
  '../../../components/molecules/Form/components/FormsComboboxMultiSelect/partials/FormsComboboxMultiselectSelection';
import FormMultiselectContainer, {
  FormMultiselectModifier,
} from '../../../components/molecules/Form/components/FormMultiselect/FormMultiselect';
import { StateFacetItem } from '../../../components/molecules/ResultListSettings/ResultListSettings';

type PrivilegedGroupsMultiSelectListItemProps = {
  selectedResult: TopContentResult;
  removeResult: (item: TopContentResult) => void;
  grantedRolesParam: PrivilegedGroupParam<'grantedRoles'>;
  groupIndex: number;
};

export function PrivilegedGroupsMultiSelectListItem({
  selectedResult,
  removeResult,
  grantedRolesParam,
  groupIndex,
}: PrivilegedGroupsMultiSelectListItemProps) {
  const id = useHtmlValidId();
  const { t } = useSonTranslation('FormsComboBoxMultiSelect');

  return (
    <>
      <FormsComboboxMultiSelectListElement>
        <FormsComboboxMultiselectSelection id={`recipient-${id}-${selectedResult.id}`} title={selectedResult.title}>
          <FormMultiselectContainer
            name={`privilegedGroups[${groupIndex}].grantedRoles`}
            title={t('glossary:role_plural')}
            items={grantedRolesParam.options as StateFacetItem[]}
            modifier={FormMultiselectModifier.ROLE_CHANGE_FORM}
          />
          <Btn
            modifier={[BtnModifier.MINOR_ACTION, BtnModifier.TRANSPARENT]}
            svgSpriteId={Icons.DELETE_X_SMALL}
            type="button"
            text={t('resultlist.deleteButtonText', { itemName: selectedResult.title })}
            titleText={t('resultlist.deleteButtonTitleText', { itemName: selectedResult.title })}
            hiddenText
            tooltipPlacement={TooltipPlacement.TOP}
            onClick={() => {
              removeResult(selectedResult);
            }}
          />
        </FormsComboboxMultiselectSelection>
      </FormsComboboxMultiSelectListElement>
      <input type="hidden" name={`privilegedGroups[${groupIndex}].groupId`} value={selectedResult.id} />
    </>
  );
}
